import { createStatic } from 'styled-components-breakpoint'
import { BREAKPOINTS_IN_PX } from 'styles/breakpoints'

const breakpoints = createStatic(BREAKPOINTS_IN_PX)
export const breakpoint = breakpoints.breakpoint
